import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NetworkStatusService } from '../util/network-status.service';

/**
 * Detects network connectivity via HTTP response status codes.
 *
 * Chrome DevTools "Offline" mode does not fire window offline/online events —
 * it only causes requests to fail with status 0. This interceptor bridges that
 * gap by forwarding HTTP-level offline/online signals to NetworkStatusService.
 */
@Injectable()
export class NetworkOfflineInterceptor implements HttpInterceptor {
  private readonly networkStatus = inject(NetworkStatusService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && !this.networkStatus.isOnline()) {
          this.networkStatus.reportHttpOnline();
        }
      }),
      catchError((error) => {
        if (error.status === 0) {
          this.networkStatus.reportHttpOffline();
        } else if (!this.networkStatus.isOnline()) {
          this.networkStatus.reportHttpOnline();
        }
        return throwError(() => error);
      }),
    );
  }
}
